import actions from './actions'

export const initUser = {
  id: '',
  name: '',
  role: '',
  email: '',
  avatar: '',
  business: {
    code: '',
    id: '',
    name: '',
  },
  loading: false,
  error: '',
  partnersData: {},
}

export default function userReducer(state = initUser, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.UPDATE_BUSINESS:
      return { ...state, business: { ...(state.business || {}), ...action.payload } }
    case actions.UPDATE_PARTNER:
      return {
        ...state,
        partnersData: {
          ...(state.partnersData || {}),
          ...action.payload,
        },
      }
    case actions.LOGOUT:
      return initUser
    default:
      return state
  }
}
